<template>
  <div id="scalebar">
    <div class="legend-container">
      <div class="legend-item">
        <span class="legend-label">75以下</span>
        <div class="legend-color legend-color--low"></div>
      </div>
      <div class="legend-item">
        <span class="legend-label">75-200</span>
        <div class="legend-color legend-color--medium"></div>
      </div>
      <div class="legend-item">
        <span class="legend-label">200以上</span>
        <div class="legend-color legend-color--high"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Scalebar'
}
</script>

<style lang="less" scoped>
// 图例样式
#scalebar {
  position: absolute;
  left: 10px;
  bottom: 20px;
  z-index: 999;
  user-select: none;
}

.legend-container {
  background: rgba(176, 192, 210, 0.9);
  //backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  gap: 16px;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-label {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
}

.legend-color {
  width: 20px;
  height: 10px;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  &--low {
    background: linear-gradient(135deg, #2de578, #1bc65a);
  }

  &--medium {
    background: linear-gradient(135deg, #03A9F4, #0288d1);
  }

  &--high {
    background: linear-gradient(135deg, #07436e, #052f4a);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .legend-container {
    flex-direction: column;
    gap: 8px;
    padding: 8px 12px;
  }

  .legend-item {
    gap: 4px;
  }

  .legend-label {
    font-size: 11px;
  }

  .legend-color {
    width: 16px;
    height: 8px;
  }
}
</style>
